import { getMobileBookingProgress } from '@components/BookingFlow/Common/bookingFlowProgress';
import { BookingStepUnavailablePage } from '@components/BookingFlow/Common/BookingStepUnavailablePage';
import { CheckoutLoginStep } from '@components/Login/CheckoutLoginStep';
import { ShoppingCartSummary } from '@components/Summary/ShoppingCartSummary';
import { plural } from '@lingui/core/macro';
import { DeliveryWindowOutputRecord } from '@navio/nsdk';
import { BookingAddress, SelectedSalesItemsCar } from 'noddi-types';
import { customerRoutes, formatCurrencyAmount } from 'noddi-util';
import { useBookingAddress, useBookingSelectedSalesItemsCars, useBookingTimeWindow } from 'noddi-web';
import { useMobileBookingCheckout } from '../../../../hooks/useMobileBookingCheckout';
import { useTrackMobileBookingFlowContext } from '../../../../hooks/useTrackMobileBookingFlowContext';

export const BookingLogin = () => {
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  const bookingTimeWindow = useBookingTimeWindow();
  const selectedAddress = useBookingAddress();
  useTrackMobileBookingFlowContext();

  if (!selectedAddress || !selectedSalesItemsCars.length) {
    return <BookingStepUnavailablePage missing={!selectedAddress ? 'address' : 'services'} />;
  }
  return (
    <BookingLoginContent
      selectedSalesItemsCars={selectedSalesItemsCars}
      bookingTimeWindow={bookingTimeWindow}
      selectedAddress={selectedAddress}
    />
  );
};

const BookingLoginContent = ({
  selectedSalesItemsCars,
  bookingTimeWindow,
  selectedAddress
}: {
  selectedSalesItemsCars: SelectedSalesItemsCar[];
  bookingTimeWindow: DeliveryWindowOutputRecord | undefined;
  selectedAddress: BookingAddress;
}) => {
  const checkout = useMobileBookingCheckout({ selectedSalesItemsCars, bookingTimeWindow, selectedAddress });

  return (
    <CheckoutLoginStep
      progress={getMobileBookingProgress('summary')}
      nextPath={customerRoutes.newBookingSummary.getPath()}
      isBookingFlow
      opensUserGroupPicker
      showsAccountDiscountNotice
      // The recap is optional here: a slow or failed cart must never hold up the login.
      isOrderLoading={!checkout.isReady && !checkout.summaryError}
      order={
        checkout.isReady
          ? {
              description: plural(selectedSalesItemsCars.length, { one: '# service', other: '# services' }),
              total: formatCurrencyAmount({ money: checkout.shoppingCart.totalPrice }),
              details: (
                <ShoppingCartSummary
                  shoppingCart={checkout.shoppingCart}
                  selectedSalesItemsCars={selectedSalesItemsCars}
                />
              )
            }
          : undefined
      }
    />
  );
};
